import { styled } from '../../../common/ui'

export const BigTitle = styled.h1`
  text-align: center;
  font-weight: bold;
  font-size: 38px;
  color: #fff;
  margin: 0 0 25px 0;
  padding: 0;
  @media all and (max-width: 600px) {
    font-size: 30px;
  }
`
